module.exports = __webpack_public_path__ + "static/media/12.a57b45b4.jpg";